// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3047":"5452b270056701ee","3350":"fe6bda8f4a1cd84b","5768":"ce292bf396cd8125"}[chunkId] + ".css";
};